import type { ReactNode } from "react";

export type OverlaySlotName = "left" | "right" | "top" | "centre" | "bottomLeft" | "bottomCentre" | "bottomRight";

export type OverlaySlotsProps = Partial<Record<OverlaySlotName, ReactNode>> & { children?: ReactNode };

export function OverlaySlots({ left, right, top, centre, bottomLeft, bottomCentre, bottomRight, children }: OverlaySlotsProps) {
  return (
    <div className="fxmap-overlay" data-fxmap="overlay">
      <div className="fxmap-slot fxmap-slot-left" data-fxmap-slot="left">
        {left}
      </div>
      <div className="fxmap-slot fxmap-slot-top" data-fxmap-slot="top">
        {top}
      </div>
      <div className="fxmap-slot fxmap-slot-centre" data-fxmap-slot="centre">
        {centre}
      </div>
      <div className="fxmap-slot fxmap-slot-bottom" data-fxmap-slot="bottom">
        <div className="fxmap-slot-bottom-left" data-fxmap-slot="bottom-left">
          {bottomLeft}
        </div>
        <div className="fxmap-slot-bottom-centre" data-fxmap-slot="bottom-centre">
          {bottomCentre}
        </div>
        <div className="fxmap-slot-bottom-right" data-fxmap-slot="bottom-right">
          {bottomRight}
        </div>
      </div>
      <div className="fxmap-slot fxmap-slot-right" data-fxmap-slot="right">
        {right}
      </div>
      {children}
    </div>
  );
}
